/* KOJI RADAR - logica condivisa: invio con fetch, suggerimenti live, placeholder a rotazione, prefill ?q= */
(function () {
  'use strict';

  var REDUCED = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var NL = String.fromCharCode(10);

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  }

  function clear(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  /* Evento di tracking (nessun dato personale): collegabile da GTM / GA4 */
  function track(source, hasEmail, category) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'koji_radar_submit', radar_source: source, radar_has_email: !!hasEmail, radar_category: category || '' });
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'generate_lead', { method: 'koji_radar', source: source });
      }
    } catch (e) {}
  }

  /* ---------- Placeholder a rotazione ---------- */
  function initPlaceholders() {
    if (REDUCED) return;
    document.querySelectorAll('[data-placeholders]').forEach(function (input) {
      if (input.getAttribute('data-koji-ph')) return;
      input.setAttribute('data-koji-ph', '1');
      var list = (input.getAttribute('data-placeholders') || '').split('||').map(function (s) { return s.trim(); }).filter(Boolean);
      if (list.length < 2) return;
      var i = 0;
      setInterval(function () {
        if (document.hidden || input.value !== '' || document.activeElement === input) return;
        i = (i + 1) % list.length;
        input.setAttribute('placeholder', list[i]);
      }, 3500);
    });
  }

  /* ---------- Suggerimenti live (prodotti gia nel catalogo) ---------- */
  function volumeMatches(query, title) {
    var m = query.match(/[0-9]+/);
    if (!m) return true;
    return new RegExp('(^|[^0-9])' + m[0] + '([^0-9]|$)').test(title);
  }

  function renderSuggestions(box, items) {
    clear(box);
    var anyAvailable = items.some(function (p) { return p.available !== false; });

    box.appendChild(el('div', 'koji-sug-header', '👀 FORSE CERCAVI TRA QUESTI?'));
    var list = el('div', 'koji-sug-list');

    items.forEach(function (p) {
      var soldOut = p.available === false;
      var a = el('a', 'koji-sug-item' + (soldOut ? ' is-soldout' : ''));
      a.href = p.url;
      a.target = '_blank';
      a.rel = 'noopener';

      if (p.image) {
        var img = el('img', 'koji-sug-img');
        img.src = p.image;
        img.alt = '';
        img.loading = 'lazy';
        a.appendChild(img);
      }

      var info = el('div', 'koji-sug-info');
      info.appendChild(el('span', 'koji-sug-title', p.title));
      var price = el('span', 'koji-sug-price', p.price ? String(p.price) : '');
      if (soldOut) price.appendChild(el('span', 'koji-sug-badge', 'ESAURITO'));
      info.appendChild(price);
      a.appendChild(info);

      a.appendChild(el('span', 'koji-sug-btn', 'SCOPRI ❯'));
      list.appendChild(a);
    });
    box.appendChild(list);

    var footerText = anyAvailable
      ? 'Se il volume o l’edizione che cerchi non è qui, invia pure il segnale!'
      : 'Al momento risulta esaurito: invia il segnale e Koji lo rimette in cerca!';
    box.appendChild(el('div', 'koji-sug-footer', footerText));
    box.style.display = 'block';
  }

  function initSuggestions(input) {
    if (input.getAttribute('data-koji-sug')) return;
    input.setAttribute('data-koji-sug', '1');
    var box = document.getElementById(input.getAttribute('data-radar-suggest'));
    if (!box) return;
    var timer = null;
    var controller = null;

    function hide() {
      box.style.display = 'none';
      clear(box);
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      if (controller) controller.abort();
      var query = input.value.trim();
      if (query.length < 3) { hide(); return; }

      timer = setTimeout(function () {
        controller = typeof AbortController === 'function' ? new AbortController() : null;
        var url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
        fetch(url, { signal: controller ? controller.signal : undefined, headers: { Accept: 'application/json' } })
          .then(function (res) {
            if (!res.ok) throw new Error('suggest ' + res.status);
            return res.json();
          })
          .then(function (data) {
            if (input.value.trim() !== query) return;
            var raw = (data.resources && data.resources.results && data.resources.results.products) || [];
            var matched = raw.filter(function (p) { return volumeMatches(query, p.title); }).slice(0, 3);
            if (matched.length) renderSuggestions(box, matched); else hide();
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            hide();
          });
      }, 350);
    });
  }

  /* ---------- Prefill dalla home (?q=) ---------- */
  function initPrefill() {
    var input = document.querySelector('.koji-radar-input[data-radar-prefill]');
    if (!input || input.getAttribute('data-koji-prefilled')) return;
    input.setAttribute('data-koji-prefilled', '1');
    try {
      var q = new URLSearchParams(window.location.search).get('q');
      if (q && !input.value) {
        input.value = q.slice(0, 140);
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    } catch (e) {}
  }

  /* ---------- Form Radar ---------- */
  function nativeSubmit(action, formData) {
    var f = document.createElement('form');
    f.method = 'post';
    f.action = action;
    f.style.display = 'none';
    formData.forEach(function (value, key) {
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = key;
      i.value = value;
      f.appendChild(i);
    });
    document.body.appendChild(f);
    f.submit();
  }

  function initForm(form) {
    if (form.getAttribute('data-koji-bound')) return;
    form.setAttribute('data-koji-bound', '1');

    var block = form.closest('.koji-radar-form-block');
    var success = block ? block.querySelector('.koji-radar-success') : null;
    var live = block ? block.querySelector('[data-radar-live]') : null;
    var submitBtn = form.querySelector('.koji-radar-submit');
    var textInput = form.querySelector('.koji-radar-input');
    var emailInput = form.querySelector('.koji-radar-email');
    var errorBox = form.querySelector('.koji-radar-error');
    var chips = form.querySelectorAll('input[name=radar_chip]');
    var source = form.getAttribute('data-radar-source') || 'radar';
    var customerEmail = form.getAttribute('data-customer-email') || '';
    var busy = false;

    if (!textInput) return;
    if (success) success.setAttribute('tabindex', '-1');

    /* Chip: un secondo click sulla chip selezionata la deseleziona */
    function syncChips() {
      chips.forEach(function (c) { c.setAttribute('data-was', c.checked ? '1' : '0'); });
    }
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (chip.getAttribute('data-was') === '1') chip.checked = false;
        syncChips();
      });
    });

    function setError(message) {
      if (!errorBox) return;
      if (message) {
        errorBox.textContent = message;
        errorBox.hidden = false;
      } else {
        errorBox.textContent = '';
        errorBox.hidden = true;
      }
    }

    function setBusy(state) {
      busy = state;
      if (!submitBtn) return;
      submitBtn.classList.toggle('is-loading', state);
      submitBtn.disabled = state;
    }

    function showSuccess(email) {
      form.classList.add('is-hidden');
      form.setAttribute('aria-hidden', 'true');
      try { form.inert = true; } catch (e) {}
      if (live) live.textContent = 'Segnale ricevuto. Koji è già al lavoro.';
      setTimeout(function () {
        if (!success) return;
        var notify = success.querySelector('[data-radar-notify]');
        if (notify) {
          notify.textContent = email ? 'Se Koji lo trova, ti avvisiamo a ' + email + '.' : '';
          notify.hidden = !email;
        }
        success.classList.add('is-active');
        try { success.focus({ preventScroll: true }); } catch (e) {}
        if (navigator.vibrate) navigator.vibrate([30, 50, 30]);
      }, 300);
    }

    function resetForm() {
      if (success) success.classList.remove('is-active');
      form.classList.remove('is-hidden');
      form.removeAttribute('aria-hidden');
      try { form.inert = false; } catch (e) {}
      textInput.value = '';
      if (emailInput) emailInput.value = '';
      chips.forEach(function (c) { c.checked = false; });
      syncChips();
      setError('');
      setBusy(false);
      var box = document.getElementById(textInput.getAttribute('data-radar-suggest') || '');
      if (box) { box.style.display = 'none'; clear(box); }
      if (live) live.textContent = '';
      textInput.focus();
    }

    var resetBtn = success ? success.querySelector('[data-radar-reset]') : null;
    if (resetBtn) resetBtn.addEventListener('click', resetForm);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;

      var text = textInput.value.trim();
      if (!text) {
        setError('Scrivi cosa vorresti trovare sugli scaffali.');
        textInput.focus();
        return;
      }

      var typedEmail = emailInput ? emailInput.value.trim() : '';
      if (typedEmail && !emailInput.checkValidity()) {
        setError('Controlla l’email: sembra che manchi qualcosa.');
        emailInput.focus();
        return;
      }
      setError('');

      var chipEl = form.querySelector('input[name=radar_chip]:checked');
      var chip = chipEl ? chipEl.value : '';
      var notifyEmail = typedEmail || customerEmail;

      var fd = new FormData(form);
      fd.delete('radar_chip');
      fd.delete('radar_email');

      var body = (chip ? '[' + chip + '] ' : '') + text;
      if (notifyEmail) body += NL + NL + 'Vuole essere avvisato se arriva: sì';
      fd.set('contact[body]', body);
      if (typedEmail) fd.set('contact[email]', typedEmail);

      var tags = String(fd.get('contact[tags]') || '');
      if (notifyEmail) tags += ', radar_avvisami';
      fd.set('contact[tags]', tags);

      setBusy(true);
      textInput.blur();
      var navigating = false;

      fetch(form.action, {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        redirect: 'follow',
        headers: { Accept: 'text/html' }
      })
        .then(function (res) {
          var finalUrl = res.url || '';
          if (finalUrl.indexOf('/challenge') !== -1) {
            /* Shopify chiede la verifica anti-bot: passo all’invio classico */
            navigating = true;
            nativeSubmit(form.action, fd);
            return;
          }
          if (res.ok && (res.redirected || finalUrl.indexOf('contact_posted=true') !== -1)) {
            track(source, !!notifyEmail, chip);
            showSuccess(notifyEmail);
            return;
          }
          throw new Error('radar ' + res.status);
        })
        .catch(function () {
          setError('Il segnale non è partito. Controlla la connessione e riprova tra un attimo.');
        })
        .then(function () {
          if (!navigating) setBusy(false);
        });
    });

    /* Ritorno dall’invio classico (verifica anti-bot) */
    if (source === 'page' && /[?&]contact_posted=true/.test(window.location.search)) {
      showSuccess('');
      try {
        var u = new URL(window.location.href);
        u.searchParams.delete('contact_posted');
        window.history.replaceState(null, '', u.pathname + u.search + u.hash);
      } catch (e) {}
    }
  }

  function init() {
    document.querySelectorAll('.koji-radar-form').forEach(initForm);
    document.querySelectorAll('.koji-radar-input[data-radar-suggest]').forEach(initSuggestions);
    initPrefill();
    initPlaceholders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
